import { action, makeObservable, observable } from 'mobx';
import { MainStore } from './MainStore';
import {
    IBookmarkArticleData,
    IBreadcrumbData,
    IGlovesRecommendation,
    IMixedMediaData,
    IOrderModuleData,
    IPurchaseAdvice,
    IResponseData,
    IShutterModule,
    IBannerModule,
    IVariantSelection,
    IContextData,
} from './types';

class DataStore {
    mainStore: MainStore;
    contextData: IContextData;
    breadcrumb: IBreadcrumbData;
    mixedMedia: IMixedMediaData;
    orderModule: IOrderModuleData;
    variantSelection: IVariantSelection;
    bookmark: IBookmarkArticleData;
    glovesRecommendation: IGlovesRecommendation[];
    shutterModule: IShutterModule;
    bannerModule: IBannerModule;
    purchaseAdvice: IPurchaseAdvice;

    constructor(initialData: IResponseData, store: MainStore) {
        this.mainStore = store;
        this.updateData(initialData);

        makeObservable(this, {
            contextData: observable,
            breadcrumb: observable,
            mixedMedia: observable,
            orderModule: observable,
            variantSelection: observable,
            bookmark: observable,
            glovesRecommendation: observable,
            shutterModule: observable,
            bannerModule: observable,
            purchaseAdvice: observable,
            updateData: action.bound,
        });
    }

    updateData(data: IResponseData) {
        this.contextData = data.contextData;
        this.breadcrumb = data.breadcrumb;
        this.mixedMedia = data.mixedMedia;
        this.orderModule = data.orderModule;
        this.orderModule.articlePrice.scalePrices = data.orderModule.articlePrice.scalePrices?.slice().sort(
            (a, b) => a.quantity - b.quantity);
        this.variantSelection = data.variantSelection;
        this.bookmark = data.bookmark;
        this.glovesRecommendation = data.glovesRecommendation;
        this.shutterModule = data.shutterModule;
        this.bannerModule = data.bannerModule;
        this.purchaseAdvice = data.purchaseAdvice;
    }
}

export default DataStore;
